// store/index.js (Corretto)

import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    // Ora salviamo l'intera risposta 'room'
    roomData: null
  },
  getters: {
    // Restituisce l'intero oggetto room
    getRoomData: (state) => state.roomData,

    // Getter per ottenere SOLO lo schema Konva se i dati della stanza esistono
    getKonvaSchema: (state) => {
      // Sicurezza: Controlla se roomData esiste prima di accedere alle sue proprietà
      return state.roomData?.jsonable?.konva_schema || null
    },

    // Getter per ottenere l'ID della stanza, utile per salvare
    getRoomId: (state) => state.roomData?.uid || null
  },
  mutations: {
    // Salva l'intera risposta JSON (che dovrebbe essere l'oggetto stanza)
    setRoomData (state, json) {
      state.roomData = json
    },

    // Mutazione per AGGIORNARE lo schema Konva all'interno dell'oggetto stanza
    updateKonvaSchema (state, konvaJson) {
      if (state.roomData && state.roomData.jsonable) {
        state.roomData.jsonable.konva_schema = konvaJson
      }
    }
  },
  actions: {
    // Azione per salvare l'intera stanza (chiamata dopo la creazione)
    aggiornaschema ({ commit }, json) {
      commit('setRoomData', json)
    },

    // Azione per aggiornare lo schema Konva (chiamata dopo il salvataggio della disposizione)
    aggiornakonova ({ commit }, konvaJson) {
      commit('updateKonvaSchema', konvaJson)
    }
  }

})
